import { ISigSyncEventType } from '../../../../types/signingAppointment/ISigSyncEventType';
import {
  getLatestActiveLineIndex,
  ISigSyncProgressionLine,
} from '../../../../types/signingAppointment/ISigSyncProgressionLine';
import { getLinesToShow } from '../SigningAppointmentDetails/AppointmentProgressions';

export const getCurrentSigSyncProgressionStatus = (
  progressions: Record<ISigSyncProgressionLine, ISigSyncEventType | null>
) => {
  if (!progressions || Object.keys(progressions).length === 0) {
    return undefined;
  }
  const progressionLines = getLinesToShow(progressions!);
  const currentActiveLine = getLatestActiveLineIndex(progressionLines, progressions!);
  return progressionLines[currentActiveLine];
};
